import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { templatesCacheKey } from './useTemplates';

export const useNewPresentationId = () => {
  const client = useQueryClient();
  const { mutate: createPresentationId } = useMutation(
    async (_: { onSuccess: (id: string) => void }) => {
      return await BackendService.instance.presentations.newPresentationId();
    },
    {
      onSuccess: (data, arg) => {
        arg.onSuccess(data.id);
        // Invalidate templates cache to get the latest template refresh if the user goes back to my lessons
        client.invalidateQueries([templatesCacheKey]);
      },
    },
  );

  return {
    createPresentationId,
  };
};
